// The store's food list (~12k foods) is frozen and replaced whole on every change
// (state/modules/food.js), so an id lookup built once per list stays valid.
const lookups = new WeakMap();

export const findFood = (foods, id) => {
    let byId = lookups.get(foods);
    if (!byId) {
        byId = new Map(foods.map(food => [food.id, food]));
        lookups.set(foods, byId);
    }
    return byId.get(id);
};
